export default store => {
  return {
    path: "userApproval",
    getComponent(nextState, cb) {
      // require.ensure([],require => {
      const comp = require("./UserApproval").default;
      cb(null, comp);
      // },"administrator-tooling");
    },
  };
};
